import { useEffect, useRef } from "react";
import { isTauriSync } from "../lib/tauri";

const GROUPS: { label: string; emoji: string[] }[] = [
  {
    label: "Vaak gebruikt",
    emoji: ["👍", "👎", "❤️", "😂", "🎉", "🙏", "👀", "🔥", "✅", "❌", "💯", "🤔"],
  },
  {
    label: "Gezichten",
    emoji: [
      "😀","😃","😄","😁","😅","😂","🤣","😊","🙂","😉","😍","🥰","😘","😎","🤓",
      "🤔","🤨","😐","😑","🙄","😏","😒","😞","😔","🙁","😣","😖","😫","🥺","😢",
      "😭","😤","😠","😡","🤯","🤐","🥱","😴","🤒","🤧",
    ],
  },
  {
    label: "Handen",
    emoji: ["👍","👎","👌","✌️","🤞","🤝","🙏","🙌","👏","💪","👋","🤚","✋","🤘","🤟"],
  },
  {
    label: "Objecten",
    emoji: ["🎉","🎊","🥳","🚀","💡","✨","⭐","🔥","💯","💩","🎯","🏆","🍕","☕","🍺","🍻"],
  },
];

type Props = {
  onPick(emoji: string): void;
  onClose(): void;
};

export default function EmojiPicker({ onPick, onClose }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const showWindowsTip = isTauriSync();

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    }
    function onEsc(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      /* 48px vanaf links plus 320px breed is 368px, en dat is meer dan een
         telefoon breed is - de rechterkolom emoji's viel buiten beeld. Onder
         `sm` spant hij daarom van rand tot rand. */
      className="absolute bottom-12 left-2 right-2 z-20 rounded-lg border border-slate-700 bg-slate-800 p-2 shadow-xl sm:left-12 sm:right-auto sm:w-80"
    >
      <div className="max-h-72 overflow-y-auto">
        {GROUPS.map((g) => (
          <div key={g.label} className="mb-2 last:mb-0">
            <div className="mb-1 px-1 text-[10px] uppercase tracking-wide text-slate-500">
              {g.label}
            </div>
            <div className="grid grid-cols-8 gap-0.5">
              {g.emoji.map((e) => (
                <button
                  key={e}
                  onClick={() => onPick(e)}
                  className="rounded p-1 text-xl hover:bg-slate-700"
                  title={e}
                >
                  {e}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      {showWindowsTip && (
        <div className="mt-1 border-t border-slate-700 pt-1 text-[10px] text-slate-500">
          Tip: Win+. opent ook Windows' eigen emoji-paneel
        </div>
      )}
    </div>
  );
}
